module.exports = __webpack_public_path__ + "img/sign-in-green.7d3073a9.svg";